import { lazyWithRetry } from "@/react/lazyWithRetry";
import type { ClientActionDescriptor } from "@/managers/ClientActionRegistry";

const ApprovalBuilderPage = lazyWithRetry(
    () => import("../components/BuilderPage").then((m) => ({ default: m.ApprovalBuilderPage })),
    "approval.builder",
);

const plugin: ClientActionDescriptor = {
    key: "approval.builder",
    component: ApprovalBuilderPage,
    paramSchema: "any",
};

export default plugin;
